<template>
	<div>
		<div v-if="slug === 'recomended-product'">
			<hr>
			<div v-if="!isEmptyObject(meta)">
				<div class="form-group">
					<label for="title" class="font-weight-bold">Widget Label</label>
					<input type="text" class="form-control" v-model="meta.title" id="title" placeholder="Label yang akan ditampilkan di homepage">
				</div>
				<hr>
			</div>
			<div class="featured-container" v-for="(item, index) in config" :key="index">
				<div class="form-group" v-if="index !== 12">
					<label for="title">Pilih Produk #{{ index+1 }}</label>
					<!-- <input type="text" class="form-control" v-model="config.product_id" id="title" placeholder="Judul banner" required> -->
					<ProductsSelectPublic
						v-model="item.product"
						@input="onSelectProduct"
					/>
				</div>
				<div class="row" v-else>
					<div class="col-12 col-lg-6">
						<div class="form-group">
							<label for="image" class="font-weight-bold">Section Image</label>
							<button class="btn btn-sm btn-plain text-danger"
								v-if="config[12].section_image_url !== undefined && config[12].section_image_url !== ''"
								@click="removeImage('recommended_product_image')">
								<i class="bi-x-circle"></i> Remove Image
							</button>
							<div class="my-2 text-center preview-image"
								v-if="config[12].section_image_url !== undefined && config[12].section_image_url !== ''">
								<img class="img-fluid rounded" :src="config[12].section_image_url" alt="Uploaded Image">
							</div>
							<div v-if="isRecommendedProductImageUploading && config[12].section_image_url === ''" class="pc-image-empty">
								<div class="image-loading">
									<div class="is-loading"></div>
								</div>
							</div>
							<div v-else-if="config[12].section_image_url === ''" class="pc-image-empty cursor-pointer"
								@click="uploadImage('recommended_product_image')">
								<div class="image-upload-placeholder">
									<i class="fi fi-rr-picture image-placeholder"></i>
									<div class="text-placeholder">
										Klik untuk upload.
									</div>
								</div>
							</div>
							<div class="pc-input-desc">
								Upload image dengan resolusi (?)x(?)px agar fit dengan ukuran banner. <!-- belum ada standar ukurannya -->
							</div>
						</div>
					</div>

					<div class="col-12 col-lg-6">
						<div class="form-group">
							<label for="background-color" class="font-weight-bold">Section Background Color</label>
							<div>
								<label>
									<input
										type="checkbox"
										class="input-checkbox input-checkbox-large"
										v-model="config[12].background_color.enabled"
									/>
									<span></span>
									<span class="input-checkbox-text">Enable Section Background Color</span>
								</label>
							</div>
							<div>
								<input
									type="color"
									v-model="config[12].background_color.color"
									:disabled="!config[12].background_color.enabled"
								>
								<label for="color" class="ml-2">Section Background Color</label>
							</div>
						</div>

						<div class="form-group">
							<label for="background-color" class="font-weight-bold">Label Text Color</label>
							<div>
								<label>
									<input
										type="checkbox"
										class="input-checkbox input-checkbox-large"
										v-model="config[12].text_color.enabled"
									/>
									<span></span>
									<span class="input-checkbox-text">Enable Label Text Color</span>
								</label>
							</div>
							<div>
								<input
									type="color"
									v-model="config[12].text_color.color"
									:disabled="!config[12].text_color.enabled"
								>
								<label for="color" class="ml-2">Label Text Color</label>
							</div>
						</div>
					</div>
				</div>
				<hr v-if="config.length !== index+1">
			</div>
		</div>
		<div v-if="slug === 'top-product'">
			<hr>
			<div v-if="!isEmptyObject(meta)">
				<div class="form-group">
					<label for="title" class="font-weight-bold">Widget Label</label>
					<input type="text" class="form-control" v-model="meta.title" id="title" placeholder="Label yang akan ditampilkan di homepage">
				</div>
				<div class="row">
					<div class="col-12 col-lg-6">
						<div class="form-group">
							<label for="image" class="font-weight-bold">Section Image</label>
							<button class="btn btn-sm btn-plain text-danger"
								v-if="config[0].section_image_url !== undefined && config[0].section_image_url !== ''"
								@click="removeImage('top_product_image')">
								<i class="bi-x-circle"></i> Remove Image
							</button>
							<div class="my-2 text-center preview-image"
								v-if="config[0].section_image_url !== undefined && config[0].section_image_url !== ''">
								<img class="img-fluid rounded" :src="config[0].section_image_url" alt="Uploaded Image">
							</div>
							<div v-if="isTopProductImageUploading && config[0].section_image_url === ''" class="pc-image-empty">
								<div class="image-loading">
									<div class="is-loading"></div>
								</div>
							</div>
							<div v-else-if="config[0].section_image_url === ''" class="pc-image-empty cursor-pointer"
								@click="uploadImage('top_product_image')">
								<div class="image-upload-placeholder">
									<i class="fi fi-rr-picture image-placeholder"></i>
									<div class="text-placeholder">
										Klik untuk upload.
									</div>
								</div>
							</div>
							<div class="pc-input-desc">
								Upload image dengan resolusi (?)x(?)px agar fit dengan ukuran banner. <!-- belum ada standar ukurannya -->
							</div>
						</div>
					</div>

					<div class="col-12 col-lg-6">
						<div class="form-group">
							<label for="background-color" class="font-weight-bold">Section Background Color</label>
							<div>
								<label>
									<input
										type="checkbox"
										class="input-checkbox input-checkbox-large"
										v-model="config[0].background_color.enabled"
									/>
									<span></span>
									<span class="input-checkbox-text">Enable Section Background Color</span>
								</label>
							</div>
							<div>
								<input
									type="color"
									v-model="config[0].background_color.color"
									:disabled="!config[0].background_color.enabled"
								>
								<label for="color" class="ml-2">Section Background Color</label>
							</div>
						</div>

						<div class="form-group">
							<label for="background-color" class="font-weight-bold">Label Text Color</label>
							<div>
								<label>
									<input
										type="checkbox"
										class="input-checkbox input-checkbox-large"
										v-model="config[0].text_color.enabled"
									/>
									<span></span>
									<span class="input-checkbox-text">Enable Label Text Color</span>
								</label>
							</div>
							<div>
								<input
									type="color"
									v-model="config[0].text_color.color"
									:disabled="!config[0].text_color.enabled"
								>
								<label for="color" class="ml-2">Label Text Color</label>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="slug === 'best-margin'">
			<hr>
			<div v-if="!isEmptyObject(meta)">
				<div class="form-group">
					<label for="title" class="font-weight-bold">Widget Label</label>
					<input type="text" class="form-control" v-model="meta.title" id="title" placeholder="Label yang akan ditampilkan di homepage">
				</div>
				<div class="row">
					<div class="col-12 col-lg-6">
						<div class="form-group">
							<label for="image" class="font-weight-bold">Section Image</label>
							<button class="btn btn-sm btn-plain text-danger"
								v-if="config[0].section_image_url !== undefined && config[0].section_image_url !== ''"
								@click="removeImage('best_margin_image')">
								<i class="bi-x-circle"></i> Remove Image
							</button>
							<div class="my-2 text-center preview-image"
								v-if="config[0].section_image_url !== undefined && config[0].section_image_url !== ''">
								<img class="img-fluid rounded" :src="config[0].section_image_url" alt="Uploaded Image">
							</div>
							<div v-if="isBestMarginImageUploading && config[0].section_image_url === ''" class="pc-image-empty">
								<div class="image-loading">
									<div class="is-loading"></div>
								</div>
							</div>
							<div v-else-if="config[0].section_image_url === ''" class="pc-image-empty cursor-pointer"
								@click="uploadImage('best_margin_image')">
								<div class="image-upload-placeholder">
									<i class="fi fi-rr-picture image-placeholder"></i>
									<div class="text-placeholder">
										Klik untuk upload.
									</div>
								</div>
							</div>
							<div class="pc-input-desc">
								Upload image dengan resolusi (?)x(?)px agar fit dengan ukuran banner. <!-- belum ada standar ukurannya -->
							</div>
						</div>
					</div>

					<div class="col-12 col-lg-6">
						<div class="form-group">
							<label for="background-color" class="font-weight-bold">Section Background Color</label>
							<div>
								<label>
									<input
										type="checkbox"
										class="input-checkbox input-checkbox-large"
										v-model="config[0].background_color.enabled"
									/>
									<span></span>
									<span class="input-checkbox-text">Enable Section Background Color</span>
								</label>
							</div>
							<div>
								<input
									type="color"
									v-model="config[0].background_color.color"
									:disabled="!config[0].background_color.enabled"
								>
								<label for="color" class="ml-2">Section Background Color</label>
							</div>
						</div>

						<div class="form-group">
							<label for="background-color" class="font-weight-bold">Label Text Color</label>
							<div>
								<label>
									<input
										type="checkbox"
										class="input-checkbox input-checkbox-large"
										v-model="config[0].text_color.enabled"
									/>
									<span></span>
									<span class="input-checkbox-text">Enable Label Text Color</span>
								</label>
							</div>
							<div>
								<input
									type="color"
									v-model="config[0].text_color.color"
									:disabled="!config[0].text_color.enabled"
								>
								<label for="color" class="ml-2">Label Text Color</label>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="slug === 'new-product'">
			<hr>
			<div v-if="!isEmptyObject(meta)">
				<div class="form-group">
					<label for="title" class="font-weight-bold">Widget Label</label>
					<input type="text" class="form-control" v-model="meta.title" id="title" placeholder="Label yang akan ditampilkan di homepage">
				</div>

				<div class="row">
					<div class="col-12 col-lg-6">
						<div class="form-group">
							<label for="image" class="font-weight-bold">Section Image</label>
							<button class="btn btn-sm btn-plain text-danger"
								v-if="config[0].section_image_url !== undefined && config[0].section_image_url !== ''"
								@click="removeImage('new_product_image')">
								<i class="bi-x-circle"></i> Remove Image
							</button>
							<div class="my-2 text-center preview-image"
								v-if="config[0].section_image_url !== undefined && config[0].section_image_url !== ''">
								<img class="img-fluid rounded" :src="config[0].section_image_url" alt="Uploaded Image">
							</div>
							<div v-if="isNewProductImageUploading && config[0].section_image_url === ''" class="pc-image-empty">
								<div class="image-loading">
									<div class="is-loading"></div>
								</div>
							</div>
							<div v-else-if="config[0].section_image_url === ''" class="pc-image-empty cursor-pointer"
								@click="uploadImage('new_product_image')">
								<div class="image-upload-placeholder">
									<i class="fi fi-rr-picture image-placeholder"></i>
									<div class="text-placeholder">
										Klik untuk upload.
									</div>
								</div>
							</div>
							<div class="pc-input-desc">
								Upload image dengan resolusi (?)x(?)px agar fit dengan ukuran banner. <!-- belum ada standar ukurannya -->
							</div>
						</div>
					</div>

					<div class="col-12 col-lg-6">
						<div class="form-group">
							<label for="background-color" class="font-weight-bold">Section Background Color</label>
							<div>
								<label>
									<input
										type="checkbox"
										class="input-checkbox input-checkbox-large"
										v-model="config[0].background_color.enabled"
									/>
									<span></span>
									<span class="input-checkbox-text">Enable Section Background Color</span>
								</label>
							</div>
							<div>
								<input
									type="color"
									v-model="config[0].background_color.color"
									:disabled="!config[0].background_color.enabled"
								>
								<label for="color" class="ml-2">Section Background Color</label>
							</div>
						</div>

						<div class="form-group">
							<label for="background-color" class="font-weight-bold">Label Text Color</label>
							<div>
								<label>
									<input
										type="checkbox"
										class="input-checkbox input-checkbox-large"
										v-model="config[0].text_color.enabled"
									/>
									<span></span>
									<span class="input-checkbox-text">Enable Label Text Color</span>
								</label>
							</div>
							<div>
								<input
									type="color"
									v-model="config[0].text_color.color"
									:disabled="!config[0].text_color.enabled"
								>
								<label for="color" class="ml-2">Label Text Color</label>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="form-group buttons m-0 hidden">
			<input type="file" accept="image/*" class="input-file" ref="imageUploader" id="pc-product-images-file"
				@change="onInputImageChange" multiple />
			<label for="pc-product-images-file" class="btn btn-primary" :class="{
				'is-loading': isImageUploading
			}">Upload images</label>
		</div>
	</div>
</template>
<script>
import mediaApi from '@/api/media';
import ProductsSelectPublic from '@/components/ProductsSelectPublic.vue';
import { isEmptyObject } from '@/lib/helper';

export default {
	name: 'Featured',
	components: {
		ProductsSelectPublic,
	},
	props: {
		slug: {
			type: String,
			default: '',
		},
		config: {
			type: Array,
			default: () => [],
		},
		meta: {},
	},
	data() {
		return {
			selectedProduct: null,
			productOptions: [
				{
					id: '1',
					text: 'Produk 1',
				},
				{
					id: '2',
					text: 'Produk 2',
				},
			],
			stateUpload: 'best_margin_image',
			isBestMarginImageUploading: false,
			isTopProductImageUploading: false,
			isNewProductImageUploading: false,
			isRecommendedProductImageUploading: false,
		};
	},
	methods: {
		onSelectProduct(e) {
			console.log(e);
		},
		isEmptyObject,
		removeImage(state) {
			this.updateStateUpload(false, '', state);
		},
		uploadImage(state) {
			this.stateUpload = state;
			const inputFile = this.$refs.imageUploader;
			inputFile.click();
		},
		updateStateUpload(isUploading = true, url = '', state = this.stateUpload) {
			switch (state) {
			case 'best_margin_image':
				this.isBestMarginImageUploading = isUploading;
				this.$set(this.config[0], 'section_image_url', url);
				break;
			case 'top_product_image':
				this.isTopProductImageUploading = isUploading;
				this.$set(this.config[0], 'section_image_url', url);
				break;
			case 'new_product_image':
				this.isNewProductImageUploading = isUploading;
				this.$set(this.config[0], 'section_image_url', url);
				break;
			case 'recommended_product_image':
				this.isRecommendedProductImageUploading = isUploading;
				this.$set(this.config[12], 'section_image_url', url);
				break;
			default:
				this.isBestMarginImageUploading = isUploading;
				this.$set(this.config[0], 'section_image_url', url);
				break;
			}
		},
		onInputImageChange(event) {
			this.updateStateUpload(true, '');

			const maxUploadSize = 3; // MB
			const input = event.target;
			for (let i = 0; i < input.files.length; i++) {
				const image = input.files[i];

				// Check File Size
				let fileSize = image.size;
				fileSize /= 1048576;

				const isFileSizeTooLarge = fileSize > maxUploadSize;

				// Show Notice if size too large
				if (isFileSizeTooLarge) {
					const noticeMessage = `'${image.name}' size is too large (max 3MB)`;
					this.$notify({
						group: 'admin-sliders',
						text: noticeMessage,
						type: 'warn',
					});
					break;
				}

				// Start Upload
				const uploadParams = new FormData();
				uploadParams.append('image', image);

				const callback = (response) => {
					this.isUploading = false;
					const path = response.data;
					const url = `${this.mediaUrlPrefix}/${path}`;
					console.log(url);

					this.updateStateUpload(false, url);
				};

				const errorCallback = (e) => {
					this.updateStateUpload(false, '');
					console.log(e);
				};

				// Upload Image
				mediaApi.uploadImage(uploadParams, callback, errorCallback);
			}
			event.target.files = null;
			event.target.value = '';
		},
	},
	computed: {
		isImageUploading() {
			return this.isBestMarginImageUploading
				|| this.isTopProductImageUploading
				|| this.isNewProductImageUploading
				|| this.isRecommendedProductImageUploading;
		},
	},
};
</script>
<style lang="scss">
	.featured-container {
		label {
			font-weight: 700;
			font-size: 16px;
			line-height: 150%;
		}

		.form-control {
			border: 2px solid #1F1F1F61;
			height: calc(2.3em + 0.75rem + 2px);
		}

		.multiselect__tags {
			border: 2px solid #1F1F1F61;
			height: calc(2.3em + 0.75rem + 2px);
		}
	}
</style>
